export const toolTips = {
    "Women Only": "Only women are allowed to attend this event",
    "Requires pre-registration": "You will need to speak to your service before attending this event",
    "Limited Tickets": "There are limited spaces available for this event",
    "Online": "This event is held online via a video application such as Zoom",
  }